export default __webpack_public_path__ + "static/media/engineoil.b2c1961f.svg";